<template>
	<div>
		<keep-alive>
			<router-view v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive"></router-view>

		<Sidebar></Sidebar>

	</div>
</template>

<script>
	import Sidebar from './components/sidebar'
	export default {
		name: "app",		
		components:{
			Sidebar
		},		
	};
</script>


  